module.exports = __webpack_public_path__ + "static/media/xleg_severe_left.2f2aec1e.png";